import settings from './settings.json';

export interface IPromotionConfig {
	baseUrl: string;
	promotionSlug: string;
	// The client key to initialise recaptcha
	recaptchaSiteKey: string;
	/**
	 * When VERCEL_ENV is preview or development,
	 * this will be used to fetch and submit forms
	 */
	stagingApiUrl: string;
	// When VERCEL_ENV is production, this will be used to fetch and submit forms
	prodApiUrl: string;
	// Dictates what form validation and form error messages are used
	supportedCountries: string[];
	useIframe: boolean;
	/**
	 * If useFingerprint is true, the Fingerprint SDK will load and generate
	 * a visitorID and send it with entry submissions
	 */
	useFingerprint: boolean;
	/**
	 * Public Fingerprint API key
	 */
	fingerprintApiKey: string;
	fingerprintEndpoint: string;
	// If enabled, the file input will have a receipt example modal and button to open it
	useReceiptExample: boolean;
	/**
	 * If this is true, inputs, buttons, the body tile and other ui elements will have rounded corners
	 * Set this to false for squared off sites (e.g. HP/Harvey Norman)
	 * The border radii for rounded elements can be further configured below.
	 */
	areElementsRounded: boolean;
	useFormProgress: boolean;
	useEntryID: boolean;
	underlineLinks: boolean;
	useOneColumnLayout: boolean;
}

/**
 * CLIENT SIDE SETTINGS ONLY. Do not store secrets here!
 * Those will live in .env and exposed only to the server and at build time.
 */
const config: IPromotionConfig = settings;
export const VERCEL_ENV = import.meta.env.VERCEL_ENV;

export default config;
